import { Provider as JotaiStoreProvider } from 'jotai';
import { BrowserRouter } from 'react-router-dom';
import { RealtimeInventoryProvider } from '../modules/portfolio/services/RealtimeInventoryProvider';
import { store } from '../shared/state/store';
import { AccountProvider } from './AccountContext';
import { AxiosInstanceProvider } from './AxiosInstanceContext';
import { DialogProvider } from './DialogContext';
import { NbLocalizationProvider } from './NbLocalizationContext';
import { NbThemeProvider } from './NbThemeContext';
import { SSEConnectionProvider } from './SSEConnectionContext';
import { SSOProvider } from './SSOProvider';
import { SnackbarProvider } from './SnackbarContext';

// Import DataGrid styles to inject it before default MUI styles while the page is loading to ensure proper style load
import { StyledEngineProvider } from '@mui/material';
import '../shared/components/data-grid/DataGrid.module.scss';

export type ContextProviderProps = { children: React.ReactNode };

export const ContextProvider = ({ children }: ContextProviderProps) => {
  return (
    <StyledEngineProvider injectFirst>
      <JotaiStoreProvider store={store}>
        <NbLocalizationProvider>
          <AxiosInstanceProvider>
            <NbThemeProvider>
              <SnackbarProvider>
                <BrowserRouter>
                  <AccountProvider>
                    <DialogProvider>
                      <SSEConnectionProvider>
                        <RealtimeInventoryProvider>
                          <SSOProvider>{children}</SSOProvider>
                        </RealtimeInventoryProvider>
                      </SSEConnectionProvider>
                    </DialogProvider>
                  </AccountProvider>
                </BrowserRouter>
              </SnackbarProvider>
            </NbThemeProvider>
          </AxiosInstanceProvider>
        </NbLocalizationProvider>
      </JotaiStoreProvider>
    </StyledEngineProvider>
  );
};
